import React from 'react'

interface Discrepancy {
  railCarId: string
  type: 'MISSING' | 'GHOST'
}

interface DiscrepancyListProps {
  discrepancies: Discrepancy[]
}

const DiscrepancyList: React.FC<DiscrepancyListProps> = ({ discrepancies }) => {
  return (
    <div className="discrepancy-list">
      <h3>Discrepancies</h3>
      {discrepancies.length === 0 ? (
        <p className="no-discrepancies">No discrepancies found</p>
      ) : (
        <ul className="discrepancy-items">
          {discrepancies.map((discrepancy) => (
            <li key={discrepancy.railCarId} className={`discrepancy-item ${discrepancy.type.toLowerCase()}`}>
              <span className="discrepancy-type">{discrepancy.type}</span>
              <span className="discrepancy-id">{discrepancy.railCarId}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default DiscrepancyList
